import { Cmask } from './mask'
import { Popup } from './popup'
import { Affix } from './affix'
import { Ranking } from './ranking'
import { Cimage } from './cimage'
import { Grid } from './grid'
import { Audio } from './audio'
import { Video } from './video'
import { Title } from './title'
import { DiyGrid } from './diyGrid'

// 定制组件 ========
import { WantGrid } from './wantgrid'
import { BillPage } from './bill'
// 定制组件 ========

// 活动开始及结束页
import { HomeBase } from "./homeBase";
import { EndBase } from "./endBase";


// 新版本组件的路由 =======
import { Collect } from './acomponent/collect'
import { NewAudio } from './acomponent/audio'
import { NewImg } from './acomponent/img'
import { NewVideo } from './acomponent/video'
import { FixLeft } from './acomponent/fixLeft'
import { FixRight } from './acomponent/fixRight'
// 新版本组件的路由 =======

export default {
    Affix,
    Popup,
    Cmask,
    Ranking,
    Cimage,
    Grid,
    Audio,
    Video,
    Title,
    DiyGrid,

    WantGrid, // 定制活动 旺旺市场活动
    BillPage, // 定制活动 年度账单活动 

    Collect, // 集卡活动组件
    NewAudio, // 音频组件[新版]
    NewImg, // 图片组件[新版]
    NewVideo, // 视频组件[新版]
    FixLeft, // 左悬浮[取代affix]
    FixRight, // 右悬浮[取代affix]

    HomeBase,
    EndBase,
}